import moment from "moment-timezone";
import { v4 as uuidv4 } from "uuid";

export const slugify = (str) => {
  if (!str) {
    return "";
  }
  if (!str.length) {
    return "";
  }

  str = str.replace(/^\s+|\s+$/g, "");

  // Make the string lowercase
  str = str.toLowerCase();

  // Remove accents, swap ñ for n, etc
  var from =
    "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
  var to =
    "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }

  // Remove invalid chars
  str = str
    .replace(/[^a-z0-9 -]/g, "")
    // Collapse whitespace and replace by -
    .replace(/\s+/g, "-")
    // Collapse dashes
    .replace(/-+/g, "-");

  if (str.charAt(0) === "-") {
    str = str.substring(1);
  }

  if (str.charAt(str.length - 1) === "-") {
    str = str.substring(0, str.length - 1);
  }

  return str;
};

export const shuffle = (array) => {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
};
export const useCombinedReducer = (combinedReducers) => {
  // Global State
  const state = Object.keys(combinedReducers).reduce(
    (acc, key) => ({ ...acc, [key]: combinedReducers[key][0] }),
    {}
  );
  // Global Dispatch Function
  const dispatch = (action) =>
    Object.keys(combinedReducers)
      .map((key) => combinedReducers[key][1])
      .forEach((fn) => fn(action));

  return [state, dispatch];
};

export const serializeUserIdForCometChat = (user_id) => {
  let serializedUserId = "__";

  let isUpperRegex = new RegExp(/^[A-Z]*$/);

  for (let index in user_id) {
    let character = user_id[index];

    if (isUpperRegex.test(character)) {
      character = character.toLowerCase();
      serializedUserId = serializedUserId.concat(character + "_");
    } else {
      serializedUserId = serializedUserId.concat(character);
    }
  }

  return serializedUserId;
};

export const deSerializeCometChatUserId = (serializedUserId) => {
  if (!serializedUserId.startsWith("__u")) {
    throw new Error("Invalid serialized ID");
  }

  let strippedPrefixId = serializedUserId.split("__u")[1];

  let userId = "u";

  for (let i = 0; i < strippedPrefixId.length; i++) {
    let character = strippedPrefixId[i];

    //if we're on the last character and it's not an underscore, then add
    if (i === strippedPrefixId.length && character !== "_") {
      userId = userId.concat(strippedPrefixId[i]);
      break;
    }

    if (character === "_") {
      continue;
    }

    let nextCharacter = strippedPrefixId[i + 1];

    if (nextCharacter === "_") {
      character = character.toUpperCase();
    }

    userId = userId.concat(character);
  }

  return userId;
};

export const validUrlTest = (url) => {
  const validUrl = new RegExp(
    /^(https?:\/\/)?(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,15}(:[0-9]{1,5})?(\/.*)?$/
  );
  return validUrl.test(url);
};

//requires http or https
export const validUrlWithProtocolTest = (url) => {
  const validUrl = new RegExp(
    /^(https?:\/\/)(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,15}(:[0-9]{1,5})?(\/.*)?$/
  );
  return validUrl.test(url);
};

export const isValidMailToLink = (url) => {
  const validUrl = new RegExp(/^mailto:([^?]+)$/);
  return validUrl.test(url);
};

export const validDomainTest = (url) => {
  const validDomain = new RegExp(
    /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/
  );
  return validDomain.test(url);
};

export const validEmailTest = (str) => {
  return /\S+@\S+\.\S+/.test(str);
};

export function formatNumberWithCommas(analyticsNumber) {
  return analyticsNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export const shortenUrlForDisplay = (url) => {
  if (typeof url !== "string") {
    return url;
  }

  const shortenedUrl = url.replace(/^(https?:\/\/)?(www\.)?/, "");
  return shortenedUrl;
};

export const formatTimestampToTextMonth = (timestampString) => {
  return moment(timestampString).format("MMM D, YYYY");
};

export const formatTimestampToTimeSinceString = (timestamp) => {
  if (!timestamp) {
    return "n/a";
  }
  if (timestamp == "2019-01-01T00:00:00.000Z") {
    return "n/a";
  }

  return moment(timestamp).fromNow();
};

module.exports.getCurrentTimestamp = function () {
  return moment.utc().format("YYYY-MM-DD HH:mm:ss.SSS Z");
};

export const getUnixTimestampFromDate = function (date) {
  return moment(date, "YYYY-MM-DD HH:mm:ss.SSS Z").unix();
};

export const isValidNameSlug = (str) => {
  if (typeof str !== "string") {
    return false;
  }

  const validNameSlug = new RegExp(/^[a-z0-9-]+$/);

  return validNameSlug.test(str);
};

export const base64Encode = function (string) {
  if (!string) {
    return "";
  }

  return Buffer.from(string).toString("base64");
};

export const base64Decode = function (b64Encoded) {
  if (!b64Encoded) {
    return "";
  }

  return Buffer.from(b64Encoded, "base64").toString();
};

module.exports.formatCommasForLargeNumber = function (numberString) {
  if (!numberString) {
    return "";
  }

  return numberString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// export const isInvalidDomain = (domains, userEmail) => {
//   if (domains.length > 0) {
//     const index = userEmail.lastIndexOf("@");
//     let isInvalid = true;
//     if (index > -1) {
//       domains.forEach((item) => {
//         if (userEmail.slice(index + 1) === item.domain) {
//           isInvalid = false;
//         }
//       });
//     }
//     return isInvalid;
//   }
//   return true;
// };

export const generateHostedUpdateSlug = function (
  host,
  companyName,
  title,
  postId
) {
  let titleSlug = slugify(title);

  const url = host + "/" + companyName + "/" + titleSlug + "-" + postId;

  return url;
};

/**
 * make a v4 uuid
 */
export const makeUUID = () => uuidv4();

